import customAxios from '../utils/customAxios';
import { useEffect, useState } from 'react';
import { GlobalVariables } from '../globalVar';

export async function fetchUserPermissions() {
  const userPermId = localStorage.getItem('userIdForPerm');
  const userToken = localStorage.getItem('token');

  if (userToken) {
    const response = await customAxios.get(`${GlobalVariables.getURL()}userPermissions/${userPermId}`, {
      headers: {
        'Authorization': 'bearer ' + localStorage.getItem('token')
      }
    });
    return response.data;
  }
  return [];
}

export function useUserPermissions() {
  const [userPermissions, setUserPermissions] = useState([]);

  useEffect(() => {
    fetchUserPermissions().then((permissions) => {
      setUserPermissions(permissions);
    });
  }, []);

  return userPermissions;
}
